// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if ({96:1,524:1}[chunkId]) return "bundle.css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};